import { sendSmsCode } from '@/services/user';
import { getCaptchaInfo } from '@/services/app';
import { SMS_CODE_DURATION } from '@/utils/constant';
import validator from '@/utils/validator';

const geetestMixin = {
  data() {
    return {
      mobile: '',
      smsCodeText: '获取验证码',
      smsCodeDisabled: true,
      duration: -1,
    };
  },
  watch: {
    mobile(val) {
      if (!validator.isMobile(val)) {
        this.smsCodeDisabled = true;
        return;
      }
      this.smsCodeDisabled = false;
    },
  },
  methods: {
    async sendSmsCode() {
      if (!validator.isMobile(this.mobile)) {
        this.$toast('请输入正确的手机号');
        return;
      }
      try {
        await sendSmsCode(this.mobile, this.smsType);
        this.smsCodeDisabled = true;
        this.duration = SMS_CODE_DURATION;
        const t = setInterval(() => {
          if (this.duration <= 0) {
            this.smsCodeText = '重新获取';
            this.smsCodeDisabled = false;
            clearInterval(t);
            return;
          }
          this.smsCodeText = `已发送(${this.duration}s)`;
          this.duration -= 1;
        }, 1000);
      } catch (e) {
        this.smsCodeDisabled = false;
      }
    },
    async geetestVerify() {
      const data = await getCaptchaInfo();
      window.initGeetest({
        gt: data.data.gt,
        challenge: data.data.challenge,
        offline: !data.data.success,
        new_captcha: true,
        product: 'bind',
      }, (captchaObj) => {
        document.getElementById('geetest-verify-sms-btn').addEventListener('click', () => {
          captchaObj.verify();
        });
        captchaObj.onReady(() => {
          console.log('onReady');
        }).onSuccess(async () => {
          this.sendSmsCode();
        }).onError(() => {
          console.log('onError');
        });
      });
    },
  },
  created() {
    this.$nextTick(() => {
      this.geetestVerify();
    });
  },
};

export default geetestMixin;
